// API基础URL
// 开发环境：使用相对路径（通过proxy代理）
// 生产环境：通过环境变量配置（构建时设置）
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// 固定页面列表
export const PAGES = [
  { code: 'about', name_zh: '关于正定', name_en: 'About Zhengding' },
  { code: 'growth', name_zh: '成长发展', name_en: 'Growth & Development' },
  { code: 'join', name_zh: '加入我们', name_en: 'Join Us' },
  { code: 'consulting', name_zh: '正定咨询', name_en: 'Zhengding Consulting' },
  { code: 'news', name_zh: '新闻动态', name_en: 'News' },
  { code: 'footer', name_zh: '全局页脚', name_en: 'Global Footer' }
];

// 字段类型（只保留文本和列表）
export const FIELD_TYPES = [
  { value: 'text', label: '文本' },
  { value: 'list', label: '列表' }
];

